import React from 'react';
import { connect } from 'react-redux';

// Components
import { PortfolioTypeLabel } from '@/views/components/misc';
import SecondaryHeader from '@/views/components/layout/SecondaryHeader';

// HOCs
import { withErrorBoundary } from '@/views/components/errors';

// Types
import Portfolio from '@/types/portfolio';
import { ReduxState } from '@/redux/modules/types';

// Utils
import { FormattedMessage } from '@/utils/i18n';
import { getPortfolioType, portfolioIsNew } from '@/utils/portfolios';
import { Inline } from '@capintel/component-lib/inline';

type StateProps = {
  portfolio: Portfolio;
};

type Props = StateProps & {
  onCancel: () => void;
};

const PortfolioEditorHeader = ({ portfolio, onCancel }: Props) => {
  const isNew = portfolioIsNew(portfolio);

  return (
    <SecondaryHeader
      className="portfolio-editor-header"
      isInModal
      onBack={onCancel}
      buttonTextToLocalized="Common.Close"
      titleElement={
        <Inline gap="100" align="center">
          <FormattedMessage id={`PortfolioEditorBuilder.Header.${isNew ? 'CreatePortfolio' : 'EditPortfolio'}`} />
          <PortfolioTypeLabel portfolioType={getPortfolioType(portfolio)} />
        </Inline>
      }
    />
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  portfolio: state.editPortfolio.portfolio,
});

export default connect(mapStateToProps)(withErrorBoundary(PortfolioEditorHeader));
